<script>
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import CustomDatePickerRange from '@components/CustomDatePickerRange'
    import Multiselect from 'vue-multiselect'
    import { mapGetters } from 'vuex'
    import {
      inventoryMethods, warehouseMethods, usersMethods
    } from '@state/helpers'
    import BaseDatatable from '@components/base-datatable'
    
    export default {
      name: 'Reports',
      page: {
        title: 'Reportes',
        meta: [
          {
            name: 'Reportes',
            content: 'Reportes',
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        BaseDatatable,
        CustomDatePickerRange,
        Multiselect,
      },
      data() {
        return {
          title: '<i class="fas fa-clipboard-check"></i> Reportes Inventario Propio',
          items: [
            {
              text: 'Reportes',
            },
            {
              text: 'Inventario Propio',
              active: true,
            },
          ],
          tableHeaders: [
            { key: 'warehouse', label: 'Bodega' },
            { key: 'opening_date', label: 'Fecha Inicio' },
            { key: 'closing_date', label: 'Fecha Fin'},
            { key: 'user', label: 'Usuario'},
            { key: 'actions', label: 'Acciones'},
          ],
          filterset: null,
          filters:{
            opening_date__gte: null,
            closing_date__lte: null,
            warehouse_id_siesa:null,
            user:null
          },
          select_warehouse:null,
          filtersDate:{
            date__gte:null,
            date__lte:null,
          },
          showComponent:true,
          loading_users:false,
          users:[],
          select_user:null,
          downloadingIndex: [],
          downloading:false,
        }
      },
      computed: {
        ...mapGetters({
            loading_warehouses: 'retina/warehouse/loading_warehouses',
            own_warehouses: 'retina/warehouse/own_warehouses',
        }),
      },
        watch: {
            filters: {
            deep: true,
            handler(filters) {
                let filters_list = []
                for (let filter in filters) {
                if (filters[filter]) {
                    filters_list.push(`${filter}=${filters[filter]}`)
                }
                }
                if (filters_list.length) {
                this.filterset = filters_list.join('&')
                }
                this.filter()
            },
            },
        },
        created() {
          const numFilas = 100;
          for (let i = 0; i < numFilas; i++) {
            this.downloading.push(false);
          }
        },
        mounted() {
            this.allWarehouse()
            this.allUsers()
        },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
        ...usersMethods,
        myProvider(ctx) {
          let context = this
          ctx = context.$table_params(ctx)
         ctx += context.filterset ? `&${context.filterset}` : ''
          const promise = context.fetchOwnInventories(ctx)
          return promise
            .then((data) => {
              return data
            })
            .catch((error) => {
              context.$axios_error_noty(error, context)
              console.log(error)
              return []
            })
        },
        allUsers() {
            this.loading_users=true
            const promise = this.fetchUsers('?page_size=50')
            return promise.then(data => {
                this.users=data.results
                this.loading_users=false
            }).catch(error => {
                this.$axios_error_noty(error, this)
                this.loading_users=false
                return []
            })
        },
        allWarehouse() {
          this.setLoadingWarehouses(true)
          return this.fetchOwnWarehouses(this.onlyWithLocations ? '?only_with_locations=true' : null)
            .then((data) => {
              this.setOwnWarehouses(data.results)
              this.setLoadingWarehouses(false)
            })
            .catch((error) => {
              this.$axios_error_noty(error, this)
              this.setOwnWarehouses([])
              this.setLoadingWarehouses(false)
              return []
            })
        },
        setFilter(filter, value) {
            if(filter=='warehouse_id_siesa' && this.select_warehouse)value=this.select_warehouse.id
            if(filter=='warehouse_id_siesa' && !this.select_warehouse){
                this.filters.warehouse_id_siesa = null
                this.clear()
                return true
            }
            if(filter=='user' && this.select_user)value=this.select_user.email
            if(filter=='user' && !this.select_user){
                this.filters.user = null
                this.clear()
                return true
            }
            this.filters[filter] = value
        },
        filter() {
            this.$refs.table.lastFilter = ''
            this.$refs.table.onFiltered()
            setTimeout(() => this.$refs.table.refresh(), 200)
        },
        clear() {
            this.filters.opening_date__gte = null
            this.filters.closing_date__lte = null
            this.filters.warehouse_id_siesa = null
            this.filters.user=null
            this.filterset = null
            this.filtersDate={date__gte:null, date__lte:null}
            this.select_warehouse=null
            this.select_user=null
            this.showComponent = false;
            this.$nextTick(() => {
                this.showComponent = true;
            });
            setTimeout(() => this.$refs.table.refresh(), 200)
        },
        getReport(id, index){
            this.downloadingIndex[index] = true;
            this.downloading = true;
            let query_format ='?id='+id
            this.fetchOwnInventoryReport(query_format)
                .then((response) => {
                  this.downloadingIndex[index] = false;
                  this.downloading = false;
                if (response.status == 204) {
                    this.$generate_toast(
                    this,
                    'info',
                    'La bodega no tiene productos en inventario'
                    )
                } else {
                    const data = response.data
                    const url = URL.createObjectURL(
                    new Blob([data], {
                        type: 'application/vnd.ms-excel',
                    })
                    )
                    let fileName = this.warehouse_selected
                    ? this.warehouse_selected
                    : ''
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                    'download',
                    `Reporte de inventario ${fileName}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                }
                })
                .catch((error) => {
                  this.downloadingIndex[index] = false;
                  this.downloading = false;
                this.$axios_error_noty(error, this)
                })
        },
      },
    }
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
        <b-card>
            <b-row>
                <b-col md="3" class="p-0" style="margin: 0 1rem 0 0">
                  <b-col>
                    <CustomDatePickerRange v-if="showComponent"
                      label='Fecha'
                      v-model="filtersDate"
                      :value_start="filtersDate.date__gte"
                      :value_end="filtersDate.date__lte"
                      @input_start="(value) => setFilter('opening_date__gte', value+' 00:00:00')"
                      @input_end="(value) => setFilter('closing_date__lte', value+' 23:59:59')"
                    />
                  </b-col>
                </b-col>
                <b-col lg="4" md="12" class="p-0" style="margin: 0 1rem 0 1rem">
                    <b-form-group
                        label="Bodegas"
                        >
                        <Multiselect
                            v-if="own_warehouses && Object.keys(own_warehouses).length > 0"
                            v-model="select_warehouse"
                            :options="own_warehouses"
                            placeholder="Seleccione una Bodega"
                            label="description"
                            track-by="description"
                            @input="setFilter('warehouse_id_siesa', '')"
                            selectLabel="+"
                            deselectLabel="×"
                            selectedLabel="✔︎"
                            :loading="loading_warehouses"
                        >
                        </Multiselect>
                        <div v-if="loading_warehouses">
                            <p class="p-2 text-info">
                              <span class="spinner-border" small role="status"></span> Cargando lista de bodegas
                            </p>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col v-if="users" lg="3" md="12" class="p-0" style="margin: 0 1rem 0 1rem">
                    <b-form-group
                        label="Usuarios"
                        >
                        <Multiselect
                            v-if="users && Object.keys(users).length > 0"
                            v-model="select_user"
                            :options="users"
                            placeholder="Seleccione un Usuario"
                            label="email"
                            track-by="email"
                            @input="setFilter('user', '')"
                            selectLabel="+"
                            deselectLabel="×"
                            selectedLabel="✔︎"
                            
                            :loading="loading_users"
                        >
                        </Multiselect>
                        <div v-if="loading_users">
                            <p class="p-2 text-info">
                              <span class="spinner-border" small role="status"></span> Cargando lista de usuarios
                            </p>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="0" class="ml-auto pt-3 pr-1 mt-1">
                    <b-button
                      class="rounded shadow-sm float-right"
                      variant="outline-primary"
                      @click="clear"
                      ><i class="fas fa-eraser"></i>
                    </b-button>
                </b-col>
            </b-row>
          <BaseDatatable
            ref="table"
            id="table1"
            :drfprovider="myProvider"
            :tableheaders="tableHeaders"
            :showFilter="false"
          >
            <template v-slot:cell(warehouse)="row">
              <span v-if="row.item.warehouse">{{row.item.warehouse.code}} - {{ row.item.warehouse.description }}</span>
            </template>
            <template v-slot:cell(opening_date)="row">
                <span v-if="row.item.opening_date">{{row.item.opening_date.replace("T", " ").slice(0, 16)}}</span>
              </template>
              <template v-slot:cell(closing_date)="row">
                <span v-if="row.item.closing_date">{{row.item.closing_date.replace("T", " ").slice(0, 16)}}</span>
              </template>
            <template #cell(actions)="row">
              <b-button
                :disabled="downloading"
                size="sm"
                variant="link"
                class="text-success"
                @click="getReport(row.item.id, row.index), warehouse_selected=row.item.warehouse.description"
              >
                <span
                  ><i class="fas fa-file-excel fa-lg"></i>
                  <span class="d-none d-md-inline">
                    Excel </span
                  >
                </span>
                <b-spinner v-if="downloadingIndex[row.index]" small label="Spinning" variant="success"></b-spinner>
              </b-button>
            </template>
          </BaseDatatable>
        </b-card>
      </Layout>
    </template>
    <style lang="scss">
    #table1 {
      .text-center {
        text-align: center;
      }
      @media screen and (max-width: 765px) {
        .w-20 {
          width: 20px !important;
        }
        .w-50 {
          width: 50px !important;
        }
        .w-170 {
          width: 170px !important;
        }
      }
      @media screen and (min-width: 766px) {
        .w-20 {
          width: 120px !important;
        }
        .w-50 {
          width: 150px !important;
        }
        .w-170 {
          width: 230px !important;
        }
      }
      .b-table-details {
        background-color: #e2e6e9;
        padding-left: 5px;
        padding-top: 5px;
        thead {
          display: none;
        }
        table td {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
    .multiselect__single {
        max-width: 100%;
        text-wrap: nowrap;
        overflow-x: clip;
    }
    </style>
    